module.exports = __webpack_public_path__ + "img/englishExam2.7eb12276.png";